import { memo, ReactElement } from 'react';
import * as S from './VActivitySubtitle.styles';
import { ReviewsBlock } from '@/entities/Reviews/ui/ReviewBlock';
import { convertRatingToStars } from '../../app/utils/mapVProductToTabs';

type VActivitySubtitleProps = {
    destination?: { name: string; code: string };
    totalReviews: number;
    rating: number;
    handleBookNow: () => void;
};

const VActivitySubtitleContainer = ({
    destination,
    totalReviews,
    rating,
    handleBookNow,
}: VActivitySubtitleProps): ReactElement => {
    const ratingStars = convertRatingToStars(rating);
    const ratingStr = rating.toFixed(1);

    return (
        <S.VActivitySubtitleContainer data-test-id="VActivity_subtitle">
            <S.VLeftSection>
                {destination && (
                    <S.VLocation>
                        <S.VLocationIcon />
                        {`${destination.name}, ${destination.code}`}
                    </S.VLocation>
                )}
                {totalReviews > 0 && (
                    <ReviewsBlock
                        ratingStars={ratingStars}
                        rating={ratingStr}
                        rateCount={totalReviews}
                        onClick={handleBookNow}
                        size="medium"
                        emptyReviewsMsg=""
                        tooltip="Click to see reviews on external site"
                    />
                )}
            </S.VLeftSection>
        </S.VActivitySubtitleContainer>
    );
};

export const VActivitySubtitle = memo(VActivitySubtitleContainer);
